import axios from 'axios';

const currentScript = document.currentScript;
const scriptUrl = currentScript.src;
const urlParams = new URL(scriptUrl).searchParams;
const pageParams = new URL(window.location.href).searchParams;
const CONTACT_CONFIG = window.any1makerContactConfig || {};
const RECAPTCHA_SITE_KEY = urlParams.get('key');
const DEBUG_RECAPTCHA = urlParams.get('debug_recaptcha') === '1'
  || pageParams.get('debug_recaptcha') === '1'
  || CONTACT_CONFIG.debugRecaptcha === true;

const data = {
  name: '',
  email: '',
  url: '',
  company: '',
  zipCode: '',
  address: '',
  tel: '',
  sales: '',
  titleCount: '30以上',
  genre: '',
  remarks: '',
  token: urlParams.get('token'),
};

const maskToken = (token) => {
  if (!token) return '';
  if (token.length <= 12) return token;
  return `${token.slice(0, 6)}...${token.slice(-6)}`;
};

const debugLog = (...args) => {
  if (!DEBUG_RECAPTCHA) return;
  console.log('[any1maker contact]', ...args);
};

debugLog('bootstrap', {
  envName: CONTACT_CONFIG.envName || '',
  recaptchaProject: CONTACT_CONFIG.recaptchaProject || '',
  recaptchaSiteKeySuffix: RECAPTCHA_SITE_KEY ? RECAPTCHA_SITE_KEY.slice(-8) : '',
  scriptUrl,
  pageUrl: window.location.href,
  csrfTokenLength: data.token ? data.token.length : 0,
});

const handleChange = (e) => {
  const key = e.target.name;
  const value = e.target.value;
  Object.assign(data, { [key]: value });

  const submitButton = document.querySelector('[data-button-submit]');
  submitButton.disabled = data.name === '' || data.email === '';
};

const escape = (text) => {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

const resetForms = () => {
  Object.assign(data, {
    name: '',
    email: '',
    url: '',
    company: '',
    zipCode: '',
    address: '',
    tel: '',
    sales: '',
    titleCount: '30以上',
    genre: '',
    remarks: '',
    token: urlParams.get('token'),
    recaptchaResponse: '',
  });

  const formContainer = document.querySelector('[data-contact-form]');
  formContainer.querySelectorAll('[data-input]').forEach((el) => {
    el.value = '';
  });
};

const sendData = (params) => {
  axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
  debugLog('sendData request', {
    fields: Array.from(params.entries()).map(([key, value]) => {
      if (key === 'token' || key === 'recaptchaResponse') {
        return [key, {
          length: String(value).length,
          masked: maskToken(String(value)),
        }];
      }

      return [key, value];
    }),
  });

  return axios({
    method: 'POST',
    url: '/api/contact_anyonemaker.php',
    data: params,
    dataType: 'json',
  }).then((response) => {
    const payload = response.data || {};
    debugLog('sendData response', {
      status: response.status,
      payload,
    });

    if (payload.error) {
      alert(payload.message);
    } else {
      alert('メールを送信しました。\n入力ただいたメールアドレスにも入力内容をお送りしていますのでご確認ください。\n\n返信が休業日を除く5営業日を経過しても届かない場合は、お手数ですが、迷惑メールのフォルダをご確認くださいませ。\nメールフォームから送信後、ご入力いただいた内容をメールにてお送りしておりますので、こちらも届かないようでしたら迷惑メールのフォルダをご確認ください。');
      resetForms();
    }
  }).catch((error) => {
    debugLog('sendData error', {
      message: error.message,
      responseStatus: error.response?.status,
      responseData: error.response?.data,
    });
    alert('エラーが発生しました');
  });
};

const getRecaptchaResponse = () => {
  debugLog('getRecaptchaResponse start', {
    hasGrecaptcha: typeof grecaptcha !== 'undefined',
    hasEnterprise: typeof grecaptcha !== 'undefined' && !!grecaptcha.enterprise,
    recaptchaSiteKeySuffix: RECAPTCHA_SITE_KEY ? RECAPTCHA_SITE_KEY.slice(-8) : '',
  });

  return new Promise((resolve, reject) => {
    grecaptcha.enterprise.ready(() => {
      debugLog('grecaptcha ready');
      grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action: 'submit' })
        .then((token) => {
          debugLog('grecaptcha token issued', {
            tokenLength: token ? token.length : 0,
            tokenMasked: maskToken(token || ''),
          });
          resolve(token);
        })
        .catch((error) => {
          debugLog('grecaptcha execute error', {
            message: error?.message || String(error),
          });
          reject(error);
        });
    });
  });
};

const onSubmit = async (e) => {
  e.preventDefault();
  const submitButton = document.querySelector('[data-button-submit]');
  submitButton.disabled = true;
  debugLog('submit start', {
    nameLength: data.name.length,
    emailLength: data.email.length,
    hasCsrfToken: !!data.token,
  });

  try {
    data.recaptchaResponse = await getRecaptchaResponse();
  } catch (error) {
    debugLog('submit aborted: recaptcha failed', {
      message: error?.message || String(error),
    });
    submitButton.disabled = false;
    alert('reCAPTCHAの取得に失敗しました');
    return;
  }

  if (!data.name || !data.email || !data.token || !data.recaptchaResponse) {
    debugLog('submit aborted: missing required fields', {
      hasName: !!data.name,
      hasEmail: !!data.email,
      hasToken: !!data.token,
      hasRecaptchaResponse: !!data.recaptchaResponse,
    });
    submitButton.disabled = false;
    return;
  }

  const params = new FormData();
  params.append('お名前', `${escape(data.name)}`);
  params.append('E-Mail', `${escape(data.email)}`);
  params.append('HP', `${escape(data.url)}`);
  params.append('会社名', `${escape(data.company)}`);
  params.append('郵便番号', `${data.zipCode}`);
  params.append('住所', `${escape(data.address)}`);
  params.append('電話番号', `${data.tel}`);
  params.append('販売実績', `${escape(data.sales)}`);
  params.append('タイトル数', `${data.titleCount}`);
  params.append('ジャンル', `${escape(data.genre)}`);
  params.append('お問い合わせ内容', `${escape(data.remarks)}`);
  params.append('token', data.token);
  params.append('recaptchaResponse', data.recaptchaResponse);

  sendData(params);
};

const ready = () => {
  const formContainer = document.querySelector('[data-contact-form]');

  formContainer.querySelectorAll('[data-input]').forEach((el) => {
    el.addEventListener('change', (e) => handleChange(e));
  });

  formContainer.addEventListener('submit', (e) => onSubmit(e));
};

document.addEventListener('DOMContentLoaded', () => {
  debugLog('DOMContentLoaded');
  ready();
});
